export default __webpack_public_path__ + "static/media/tech1.7a2cc1ed.png";